import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { loader } from "graphql.macro";

// import components
import BranchSingle from "./BranchSingle";
import DrawRequest from "./BranchSingle/DrawRequests/index";

// load graphql query
const GET_BRANCHES_QUERY = loader("../graphql/GET_BRANCHES_QUERY.graphql");

const App = () => {
  return (
    // Set basename to ensure all routes are prefixed with /huffmanteam
    <Router basename="/huffmanteam">
      <Switch>
        <Route exact path="/" render={() => <BranchSingle id="a2APo0000000Io9MAE" />} />
        <Route path="/draw-request" component={DrawRequest} />
      </Switch>
    </Router>
  );
};

export default App;
